import { useEffect } from "react";
import "./App.css";
import "./elementor.css";
import "./color-rhythm.css";
import "./generated-visuals.css";
import "./final-polish.css";
import "./content-updates.css";
import "./real-testimonials.css";
import "./reference-layout.css";
import "./dec-brand-polish.css";
import { Header, Hero, MediaStrip, Question, Vocation, QuoteSection, Results } from "./sections/Top";
import { ErrorSection, TwoPaths, Cases, Different, ForYou } from "./sections/Middle";
import { Bonus, WhoAmI, Testimonials, FinalCTA, Footer } from "./sections/Bottom";

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const generatedImageStyles = {
    "--generated-escritorio": `url(${process.env.PUBLIC_URL}/assets/generated/escritorio-terapeutico.webp)`,
    "--generated-casos": `url(${process.env.PUBLIC_URL}/assets/generated/casos-clinicos.webp)`,
    "--testimonial-1": `url(${process.env.PUBLIC_URL}/assets/testimonios/trauma-opinion-01.webp)`,
    "--testimonial-2": `url(${process.env.PUBLIC_URL}/assets/testimonios/trauma-opinion-02.webp)`,
    "--testimonial-3": `url(${process.env.PUBLIC_URL}/assets/testimonios/trauma-opinion-03.webp)`,
    "--testimonial-4": `url(${process.env.PUBLIC_URL}/assets/testimonios/trauma-opinion-04.webp)`,
    "--testimonial-5": `url(${process.env.PUBLIC_URL}/assets/testimonios/trauma-opinion-05.webp)`,
  };

  return (
    <div className="landing" data-testid="landing-page" style={generatedImageStyles}>
      <Header />
      <main>
        <Hero />
        <MediaStrip />
        <Question />
        <Vocation />
        <QuoteSection />
        <Results />
        <ErrorSection />
        <TwoPaths />
        <Cases />
        <Different />
        <ForYou />
        <Bonus />
        <WhoAmI />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
